import { P2GBox } from '@parcel2go/core-ui';

export const MobileButtonBox = ({ children }: { children: React.ReactNode }) => (
  <P2GBox
    sx={{
      cursor: 'pointer',
      backgroundColor: 'white',
      display: 'flex',
      width: 45,
      height: 45,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '10px',
      border: (t) => `1px solid ${t.palette.grey[100]}`
    }}
  >
    {children}
  </P2GBox>
);
